<template>
    <div>
        
      <div class="header-content">
        <div style="padding-top: 3px;">
          <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="68px">
            <el-form-item label="道具名称" prop="itemName">
              <el-input
                v-model="queryParams.itemName"
                placeholder="请输入道具名称"
                clearable
                @keyup.enter.native="handleQuery"
              > <el-button slot="append" icon="el-icon-search" @click="queryShop"></el-button></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--商品展示栏-->
      <div class="content">
        <el-row :gutter="10" style="padding: 15px;" >
          <el-col :span="4" v-for="(o, index) in shopList" :key="index" style="padding-bottom: 10px;">
            <el-card :body-style="{ padding: '0px' }">
              <el-tooltip class="item" effect="dark" placement="right">
                <!--详情-->
                  <div slot="content" style="width: 300px;" class="detail-title">
                    <span class="detail-title" style="color: rgb(246, 0, 0);" v-if="detail.title">{{ detail.title }}的</span><br/>
                    <span v-for="(nr,nrindex) in detail.nruc" :key="nrindex">
                      <i class="el-icon-star-on" style="color: yellow;"></i>
                      <span v-if="(1+nrindex) % 5 == 0">    </span>
                      <span v-if="(1+nrindex) % 10 == 0"><br/></span>
                    </span><br/>

                    <span class="detail-title" style="font-weight: 900;font-size: 15; color: red;">{{ o.item_name }}（+{{ detail.ncuc }}）</span><br/>
                    <span class="detail-title"  style="font-weight: 900;font-size: 10; color: white;">{{ detail.grade == 20 ? 'SS级' : 'SS以下' }}</span>
                    <span>
                      <el-row>
                        <el-col :span="8">
                          <el-image
                              style="width: 50px; height: 50px"
                              :src="o.item_icon"></el-image>
                        </el-col>
                        <el-col :span="16">
                     
                        </el-col>
                      </el-row>
        
                      <el-row style="color: rgb(45, 240, 240);"> <el-col :span="6">分类:</el-col> <el-col :span="4"><span style="font-weight: 900;font-size: 15;">{{ o.item_type_name }}</span></el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">星之力：</el-col><el-col :span="4">  {{ detail.nCHUC }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);"> <el-col :span="6">力量：</el-col><el-col :span="4">    {{ detail.str }}</el-col></el-row> 
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">敏捷：</el-col><el-col :span="4">    {{ detail.dex }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">智力：</el-col><el-col :span="4">    {{ detail.int }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">运气：</el-col><el-col :span="4">    {{ detail.luk }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">生命：</el-col><el-col :span="4">    {{ detail.maxhp }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">蓝量： </el-col><el-col :span="4">   {{ detail.maxmp }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">攻击：</el-col><el-col :span="4">    {{ detail.pad }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">魔法力：</el-col><el-col :span="4">    {{ detail.mad }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">防御力：</el-col><el-col :span="4">    {{ detail.pdd }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">手艺：</el-col><el-col :span="4">    {{ detail.craft }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">速度：</el-col><el-col :span="4">    {{ detail.speed }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">跳跃：</el-col><el-col :span="4">    {{ detail.jump }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">BOSS伤害：</el-col><el-col :span="4">   {{ detail.bdr }}% </el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">无视防御：</el-col><el-col :span="4">    {{ detail.ipdr }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">总伤害：</el-col><el-col :span="4">    {{ detail.damr }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">所有属性：</el-col><el-col :span="4">    {{ detail.statr }}%</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">金锤子：</el-col><el-col :span="4">    {{ detail.nIUC }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">白金锤子：</el-col><el-col :span="4">    {{ detail.iuc2 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">到期: </el-col><el-col :span="4">   {{ detail.expiredate == '3439728000000' ? "永久" : '有期限' }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">可强化次数: </el-col><el-col :span="4">   {{ detail.nRUC }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="7">已经强化次数：</el-col><el-col :span="4">    {{ detail.nCUC }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="7">破功：</el-col><el-col :span="11">    {{ detail.limitbreak }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能1：</el-col><el-col :span="4">    {{ detail.option1 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能2：</el-col><el-col :span="4">    {{ detail.option2 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能3：</el-col><el-col :span="4">    {{ detail.option3 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能4：</el-col><el-col :span="4">    {{ detail.option4 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能5：</el-col><el-col :span="4">    {{ detail.option5 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">潜能6：</el-col><el-col :span="4">    {{ detail.option6 }}</el-col></el-row>
                      <el-row style="color: rgb(45, 240, 240);">  <el-col :span="6">已剪刀次数:</el-col><el-col :span="4">    {{ detail.cuttable }}</el-col></el-row>
                    </span>
                  </div>
                  <el-image :src="o.item_icon" class="image" @mouseover="shopDetail(o.iid)"/>
              </el-tooltip>
             
              <div style="padding: 14px;">
                <span>{{ o.item_type_name  }}  -   {{  o.item_name }}</span>
                <div class="bottom clearfix">
                  <time class="time">￥<span style="color: red;">{{ o.meso }}</span>元</time>
                  <el-button type="success" class="button" @click="payShopBtn(o)">购买</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="foo-content">
        <div style="padding-top: 3px;float: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
      </div>
      
        <el-dialog
          title="支付"
          :visible.sync="wxPayDialogVisible"
          width="50%"
          :before-close="handleClose" center>
       
            <div style="display: none"></div>
            <div ref="alipayWeb" v-html="alipay"></div>
            <span style="margin-left: 90px;">
              <el-row style="margin-left: 110px;">
                <el-col :span="3">
                  <el-image
                      style="width: 100px; height: 100px"
                      :src="curPayShop.item_icon"></el-image>
                </el-col>
                <el-col :span="21">
                  <p>名称: <span style="font-weight: 900;font-size: 15;">{{ curPayShop.item_name }}</span></p>
                  <p>类别: <span style="font-weight: 900;font-size: 15;">{{ curPayShop.item_type_name }}</span></p>
                  <p>金额: ￥<span style="color: red;">{{ curPayShop.meso }}</span>元</p>
                </el-col>
              </el-row>
            </span>
                  
            <span style="height: 50px;"></span>
            <div class="form-class">
         
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="账号" prop="game_account_name">
                        <el-input v-model="ruleForm.game_account_name"></el-input> 
                        <el-button type="success" icon="el-icon-search" class="get-role" @click="getCharList" :loading="queryCharBtn">获取游戏角色</el-button>
                    </el-form-item>
                    <el-form-item label="角色" prop="game_char_id">
                        <el-select v-model="ruleForm.game_char_id" placeholder="请选择角色">
                            <el-option
                                v-for="item in options"
                                :key="item.game_char_id"
                                :label="item.game_char"
                                :value="item.game_char_id">
                            </el-option>
                        </el-select><span style="font-size: small; color: red;">输入游戏账号后，通过点击《获取游戏角色》加载角色信息</span>
                    </el-form-item>
                    <el-form-item label="支付方式" prop="pay_way">
                        <el-radio-group v-model="ruleForm.pay_way">
                        <el-radio label="1" style="color: chartreuse;">  <el-image
                          style="width: 70px; height: 30px"
                          :src="alipayLogo"></el-image></el-radio>
                        <el-radio label="2" style="color: chartreuse;"><el-image
                          style="width: 30px; height: 30px"
                          :src="weixinPayLogo"
                          ></el-image>微信</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                    </el-form-item>
                </el-form>
            </div>
    
          <div v-if="isShow">
            <span style="margin-left: 40%;">  <el-image   :src="pay_qrcode"></el-image></span>
            <span v-if="tipFlag" style="color: red;">{{ tip }}</span>
            <span v-else style="color: green;">{{ tip }}</span>
          </div>
        </el-dialog>

    </div>
</template>
<script>
import alipayLogo from '@/assets/alipay.png'
import weixinPayLogo from '@/assets/weixintubiao.png'
import {Form, Message} from 'element-ui';
  export default {
    data() {
      return {
        totalNum:0,
        isShow:false,
        curPayShop:{},
        shopList:[],
        currentDate: new Date(),
        wxPayDialogVisible:false,
        weixinPayLogo:weixinPayLogo,
        alipayLogo:alipayLogo,
        detail:{},
        queryParams:{
          itemName:null,
          serviceId:null,
          itemType:null,
          pageNum:1,
          pageSize:30
        },
        ruleForm: {
          game_account_name: '',
          service_id:'',
          remark:'',
          game_char_id: '',
          game_account_id:0,
          user_type:1,
          type: 0,
          pay_way: '',
          price:0
        },
        alipay:'',
        tip:'请扫码支付',
        tipFlag:false,
        pay_qrcode:'',
        options:[],
        orderNo:'',
        timerNum:0,
        server_name:'',
        pay_scale:1,
        type:1,
        qq_contact:'',
        serverDetail:{},
        queryCharBtn:false,
        timer:null,
        payBtn:false,
        rules: {
          game_account_name: [
            { required: true, message: '请输入游戏账号', trigger: 'blur' },
          ],
          game_char_id: [
            { required: true, message: '请选择游戏角色', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请填写金额', trigger: 'blur' }
          ],
          pay_way: [
            { required: true, message: '请选择支付方式', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      getShopList(){
          let self = this;
          self.postRequest('/shop/list',self.queryParams).then(resp =>{
                if(resp.err >= 500){
                  Message.error({message: resp.msg});
                  return;
                }
                self.shopList = resp.data.rows;
                self.queryParams.pageSize = resp.data.pageSize;
                self.totalNum = resp.data.pagecount;
          })
      },
      shopDetail(iid){
          let self = this;
          let rparams = {
            'iid':iid,
            serviceId:this.queryParams.serviceId
          };
          self.postRequest('/shop/detail',rparams).then(resp =>{
                if(resp.err >= 500){
                  Message.error({message: resp.msg});
                  return;
                }
                self.detail = resp.data;
          })
      },
      handleQuery(){

      },
      resetQuery(){

      },
      queryShop(){
        this.getShopList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.queryParams.pageSize = val;
        this.getShopList();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.queryParams.pageNum = val;
        this.getShopList();
      },
      getCharList(){
            let self = this;
            self.queryCharBtn = true;
            self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 self.queryCharBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.options = resp.data;
                 if(self.options.length > 0){
                    self.ruleForm.game_account_id = self.options[0].game_account_id;
                 }
                 Message.success({message: '加载成功，请选择角色'});
            })

      },
      payShopBtn(val){
        this.curPayShop = val;
        this.ruleForm.price = val.meso
        this.wxPayDialogVisible = true;
      },
      submitForm(formName) {
        let self = this;
        self.payBtn = true;
        self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/saas/plate/order/hpay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                if(self.ruleForm.pay_way == 1){
                    //self.alipay = resp.data.sign;
                    self.pay_qrcode = resp.data.qrcode;
                    self.orderNo = resp.data.order_no;
                    self.wxPayDialogVisible=true;
                   //// self.$nextTick(()=>{
                     //   self.$refs.alipayWeb.children[0].submit();
                   // });
                }else if(self.ruleForm.pay_way == 2){
                    self.pay_qrcode = resp.data.qrcode
                    self.orderNo = resp.data.order_no;
                    self.wxPayDialogVisible=true;
                }
                self.queryOrder();

            })
          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getParam(){
        let self = this;
        var url = window.location.href ;             //获取当前url
        var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var csstr = dz_url.split('?')[1];                //获取?之后的参数字符串
        var cs_arr = csstr.split('&');                    //参数字符串分割为数组
        var cs={};
        for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
            cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
        self.ruleForm.service_id = cs.service_id;                                           //这样就拿到了参数中的数据
        self.queryParams.serviceId =  cs.service_id;  
        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                 
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
                self.pay_scale = resp.data.pay_scale;
                self.qq_contact = resp.data.qq_contact;
            })

       

      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      queryOrder(){
        let self = this;
        self.timer = setTimeout(() => {
          //需要定时执行的代码
          console.debug("Hello World:"+self.timerNum);
          let q = {
            order_no:self.orderNo
          };
          if(self.timerNum >= 15){
            clearTimeout(self.timer);
            self.tip="支付失败，如已支付，请联系客服";
            Message.error({message: "支付失败，如已支付，请联系客服"});
            return;
          }
          self.postRequest('/order/query',q).then(resp =>{
                 self.timerNum++;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    clearTimeout(self.timer);
                    return;
                 }
                 self.tip="查询支付结果中.....";
                 let order = resp.data;
                 if(order){
                  var payStatus = order.pay_status;
                  if(payStatus == 1){
                    self.tip="支付成功";
                    Message.success({message: "支付成功"});
                    self.tipFlag = false;
                    clearTimeout(self.timer);
                  }
      
                 }
            
            })
            self.queryOrder();
          }, 5000)
      }
    },
    created(){
        this.getParam();
        this.getShopList();
    }
  }
</script>
<style scoped>
    .title-class{
        padding-left: 140px;
        padding-top: 30px;
    }
    .get-role{
        margin-left: 10px;
    }
    .content{
        margin: 0 auto;
       
        align-content: center;
        width: 70%;
        height: 900px;
        max-height: 1000px;
        background-color: rgb(242, 248, 249);
        border-radius: 10px;
    }
    .form-class{
        padding-top: 20px;
        padding-left: 90px;
        width: 60%;
    }
  .header-content{
    
    margin: 0 auto;   
    margin-bottom: 5px;
    align-content: center;
    width: 70%;
    height: 40px;
    background-color: rgb(242, 248, 249);
    border-radius: 10px;
  }
  .foo-content{
    margin: 0 auto;   
    margin-top: 5px;
    align-content: center;
    width: 70%;
    height: 40px;
    background-color: rgb(242, 248, 249);
    border-radius: 10px;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 11px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100px;
    height: 100px;
    display: block;
    align-content: center;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both;
  }
  .detail-title{
   /**margin-left: 120px; */ 
   text-align: center;
  }

</style>